export default {

	/**
	 * 添加String Json数据
	 * @param key
	 * @param value
	 */
	setJsonData(key, value) {
		window.localStorage.setItem(key, JSON.stringify(value));
	},

	/**
	 * 获取String Json数据
	 * @param key
	 * @param value
	 */
	getJsonData(key) {
		return JSON.parse(this.getStringData(key) || '[]')
	},

	/**
	 * 添加String 数据
	 * @param key
	 * @param value
	 */
	setStringData(key, value) {
		window.localStorage.setItem(key, value);
	},

	/**
	 * 获取String 数据
	 * @param key
	 * @param value
	 */
	getStringData(key) {
		return window.localStorage.getItem(key) || ''
		// return window.localStorage.getItem(key) || '[]'
	},

	/**
	 * 删除对应key存储的数据
	 * @param key
	 */
	removeItemData(key) {
		return window.localStorage.removeItem(key)
	},

	/**
	 * 删除所有数据
	 * @param key
	 */
	removeAllData() {
		return window.localStorage.clear()
	},

	// 设置历史账号
	setAccount() {
		let accountList = null
		if (this.getStringData('account')) {
			accountList = this.getStringData('account')
			setTimeout(() => {
				this.setStringData('account', accountList);
			}, 1000)
		}
	},
}